/**
 * Validation utilities for equipment modal
 */

/**
 * Validates that all active assets have asset numbers filled
 * @param {Array} assets - Array of asset objects
 * @returns {Object|undefined} - Returns the first asset with missing asset number, or undefined if all valid
 */
export const validateMissingAsset = (assets) => {
  return assets.find((a) => !(a?._destroy || a?.destroy) && !a.assetNumber?.trim())
}

/**
 * Finds duplicate asset numbers among active assets
 * @param {Array} assets - Array of asset objects
 * @returns {string|undefined} - Returns the duplicate asset number, or undefined if no duplicates
 */
export const findDuplicateAssetNumber = (assets) => {
  const activeAssetNumbers = assets
    .filter((a) => !(a?._destroy || a?.destroy))
    .map((a) => a.assetNumber?.trim())
    .filter(Boolean)

  const seenNumbers = new Set()
  return activeAssetNumbers.find((num) => {
    if (seenNumbers.has(num)) return true
    seenNumbers.add(num)
    return false
  })
}
